import React from 'react';
import TextFieldWithValidation from "../input/TextFieldWithValidation";
import {Autocomplete} from '@mui/material';
import {companyAccountsStore} from "../../store/CompanyAccounts";
import {AccountCodeDto} from "../../model/AccountCodeDto";
import {observer} from "mobx-react";

interface IProps {
    value?: string,
    label: string,
    placeholder: string,
    errorText?: string,
    hasError?: any | boolean | null | undefined,
    onChanged: (code: string | undefined) => void,
}

interface IState {
}

@observer
export default class AccountCodeSelector extends React.Component<IProps, IState> {

    render() {
        const {onChanged, value, label, placeholder, errorText, hasError} = this.props;
        return <>
            <Autocomplete
                    id="acc-code-select"
                    aria-describedby="acc-code-select-helper"
                    aria-required
                    isOptionEqualToValue={(o, v) => o.id === v.id}
                    value={this.findByAccCode(value)}
                    options={this.getAccountCodeSelectorOptions()}
                    groupBy={(option) => option.group}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => <>
                        <TextFieldWithValidation {...params}
                                                 label={label}
                                                 hasError={hasError}
                                                 placeholder={placeholder}
                                                 errorText={errorText}
                        />
                    </>}
                    onChange={(e, value) => onChanged(value ? value.id : undefined)}
                    fullWidth
            />
        </>;
    }

    private getAccountCodeSelectorOptions() {
        return companyAccountsStore.accounts.map(it => {
            return this.convertForAccountCodeSearch(it)
        });
    }

    private findByAccCode(code: string | undefined) {
        if (code) {
            const accCode = companyAccountsStore.accounts.find(c => c.accountCode === code);
            if (accCode) {
                return this.convertForAccountCodeSearch(accCode)
            }
        }
        return null;
    }

    private convertForAccountCodeSearch(it: AccountCodeDto) {
        return {
            group: it.accountCode[0].toUpperCase() + 'XXX',
            id: it.accountCode,
            label: it.accountCode + " " + it.name,
        };
    }

}